import * as _4 from 'lodash4';
import { APAlternatePlanDetailsSlot } from '../../../alternate_plans/builders/ap_alternate_plan_details_slot_builder';
import {
  APAlternatePlanComparePlansQuery,
  IAPAlternatePlanComparePlanIndividualDetails
} from '../../../alternate_plans/queries/alternate_plan_compare_plans_query';
import { APUserModeConfig } from '../../../global/components/user_mode_config/config/ap_user_mode_config';
import { RouterHelper } from '../../../global/helpers/router_helper';
import {
  SlotStatusCssClassColorMap,
  SlotStatusTextMap,
  SlotStatusTextToColorMap
} from '../../../plan/components/slot_status_badge/servants/slot_status_badge_html_servant';

class AlternatePlanDetails {
  private planDetails: IAPAlternatePlanComparePlanIndividualDetails;
  private showBasePlanWarning: boolean = false;
  private advisorLabel: string;
  private showAdvisorMeetLink: boolean = false;
  private showChangeToThisButton: boolean = false;
  private isCurrentPlan: boolean = false;
  private isSelectableByStudent: boolean = false;
  private isVisibleToStudent: boolean = false;
  private noCoursesAvailable: boolean = false;
  private basePlanWarningText: string = '';

  constructor(
    private $state: ng.ui.IStateService,
    private appConfigModel: any,
    private routerHelper: RouterHelper,
    private ngAPUserModeConfig: APUserModeConfig,
    private ngAPAlternatePlanComparePlansQuery: APAlternatePlanComparePlansQuery
  ) {}

  getSlotBadge(slot: APAlternatePlanDetailsSlot) {
    return {
      cssClass: SlotStatusCssClassColorMap[SlotStatusTextToColorMap[slot.status]],
      text: SlotStatusTextMap[slot.status]
    };
  }

  initialize() {
    this.advisorLabel = _4.get(this.appConfigModel, 'model.member_configs.advisor_label', 'advisor');

    this.showAdvisorMeetLink = this.ngAPUserModeConfig.isStudent() && this.planDetails.has_plan_exist;
    if (this.planDetails.has_plan_exist) {
      this.isCurrentPlan = _4.get(this.planDetails, 'plan.is_current_plan', false);

      this.isSelectableByStudent = _4.get(this.planDetails, 'plan.is_selectable_by_student', false);
      this.isVisibleToStudent = _4.get(this.planDetails, 'plan.is_visible_to_student', false);

      // for advisor we will show this button by default if its not current plan
      this.showChangeToThisButton = !this.isCurrentPlan;
      if (this.ngAPUserModeConfig.isStudent()) {
        this.showChangeToThisButton = this.showChangeToThisButton && this.isSelectableByStudent;
        this.isVisibleToStudent = false;
      }

      this.noCoursesAvailable = _4.get(this.planDetails, 'plan.slots.length', 0) === 0;
      if (this.showAdvisorMeetLink) {
        this.showAdvisorMeetLink = !this.isCurrentPlan && !this.isSelectableByStudent;
      }
    }
    this.basePlanWarningText = `This base plan is out of date with your calendar year start date. Please update you base plan by selecting '${this.ngAPAlternatePlanComparePlansQuery.result.correctBasePlanName}' plan on the left.`;
  }

  showChangePlanPopup() {
    this.$state.go('.change-plan');
  }

  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }
}
angular.module('capability-ng-academic-planner').component('alternatePlanDetails', {
  templateUrl:
    'capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_details/alternate_plan_details.html',
  controller: AlternatePlanDetails,
  bindings: {
    planDetails: '<',
    showBasePlanWarning: '<'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_details/alternate_plan_details.ts